(function () {
  if (window.cartUpsellInitialized) {
    if (typeof window.insertSectionCartDrawer === 'function') {
      window.insertSectionCartDrawer();
    }
    return;
  }
  window.cartUpsellInitialized = true;
  window.cartUpsellLoaded = true;
  // Browsers the old code left in Shopify's preview mode of the LIVE theme (a shopper saw the black preview bar):
  // end it with one quiet request. Never in the theme editor, never while another theme is being previewed.
  (function endLivePreview() {
    try {
      const S = window.Shopify;
      if (!S || S.previewMode !== true || S.designMode || !S.theme || S.theme.role !== 'main') return;
      try {
        if (window.sessionStorage.getItem('aliceLivePreviewEnded')) return;
        window.sessionStorage.setItem('aliceLivePreviewEnded', '1');
      } catch (e) { /* storage blocked: still try */ }
      fetch('/?preview_theme_id=', { credentials: 'same-origin' }).catch(function () {});
    } catch (e) { /* never break the cart */ }
  })();
  // Event delegation for tab switching
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.cart-drawer-upsell-tab');
    if (!tab) return;

    event.preventDefault();

    const container = tab.closest('#cart-drawer-upsell');
    if (!container) return;

    const allTabs = container.querySelectorAll('.cart-drawer-upsell-tab');
    allTabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    const target = tab.dataset.tabTarget;
    const carousels = container.querySelectorAll('.cart-drawer-upsell-carousel-wrapper');
    carousels.forEach(c => {
      if (c.id === `${target}-carousel`) {
        c.style.display = 'block';
      } else {
        c.style.display = 'none';
      }
    });
  });

  // Event delegation for desktop click-and-drag scrolling (Carousel Slide)
  let isDown = false;
  let startX;
  let scrollLeft;
  let activeCarousel = null;
  let hasDragged = false;

  document.addEventListener('mousedown', (e) => {
    const carousel = e.target.closest('.cart-drawer-upsell-carousel');
    if (!carousel) return;
    const container = carousel.closest('.cart-drawer-upsell-container');
    if (container && container.dataset.layoutStyle === 'grid') return;
    isDown = true;
    activeCarousel = carousel;
    hasDragged = false;
    carousel.classList.add('active-dragging');
    carousel.style.scrollBehavior = 'auto';
    carousel.style.scrollSnapType = 'none';
    startX = e.pageX;
    scrollLeft = carousel.scrollLeft;
  });

  document.addEventListener('mouseleave', () => {
    if (!activeCarousel) return;
    isDown = false;
    activeCarousel.classList.remove('active-dragging');
    activeCarousel.style.scrollBehavior = '';
    activeCarousel.style.scrollSnapType = '';
    activeCarousel = null;
  });

  document.addEventListener('mouseup', (e) => {
    if (!activeCarousel) return;
    isDown = false;
    activeCarousel.classList.remove('active-dragging');
    activeCarousel.style.scrollBehavior = '';
    activeCarousel.style.scrollSnapType = '';
    
    // Prevent accidental clicks on child links or buttons if the user was dragging
    if (hasDragged) {
      const preventClick = (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        document.removeEventListener('click', preventClick, true);
      };
      document.addEventListener('click', preventClick, true);
    }
    
    activeCarousel = null;
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDown || !activeCarousel) return;
    const x = e.pageX;
    const walk = (x - startX) * 1.5; // Drag speed multiplier
    if (Math.abs(walk) > 5) {
      hasDragged = true;
    }
    activeCarousel.scrollLeft = scrollLeft - walk;
  });

  // Prevent default native browser drag on images and links in the carousel
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest('.cart-drawer-upsell-carousel')) {
      e.preventDefault();
    }
  });

  // Prevent text selection when activeCarousel dragging is in progress
  document.addEventListener('selectstart', (e) => {
    if (activeCarousel) {
      e.preventDefault();
    }
  });

  async function loadRecommendations(container, liveCartPromise) {
    const recommendationsList = container.querySelector('#cart-drawer-recommendations-list');
    if (!recommendationsList) return;
    
    if (recommendationsList.dataset.loaded === 'true') return;

    // The template this container is cloned from is rendered at page load and
    // can be stale (empty cart then, items now) — so ask the live cart which
    // product to recommend for; the template's value is only the fallback.
    let firstProductId = container.dataset.firstItemProductId;
    const liveCart = await (liveCartPromise || fetchLiveCart());
    if (liveCart && Array.isArray(liveCart.items) && liveCart.items.length > 0) {
      firstProductId = String(liveCart.items[0].product_id);
    }
    const wrapper = container.querySelector('#recommended-carousel');
    const limit = wrapper ? (wrapper.dataset.limit || 6) : 6;

    if (!firstProductId || firstProductId === '') {
      // Cart is empty, but we keep the Recommended tab visible as fallback
      const recommendedTabBtn = container.querySelector('.cart-drawer-upsell-tab[data-tab-target="recommended"]');
      if (recommendedTabBtn) recommendedTabBtn.style.display = '';
      if (wrapper && recommendedTabBtn && recommendedTabBtn.classList.contains('active')) {
        wrapper.style.display = 'block';
      }
      return;
    }

    try {
      let recsUrl = `/recommendations/products?section_id=cart-upsell-recommendations&product_id=${firstProductId}&limit=${limit}`;
      // Only a preview of a theme that is NOT the live one needs the theme id here. Sent on the live theme, this
      // parameter switched every shopper with a product in the cart into Shopify's preview mode (black preview
      // bar, cookie banner) from the next page on.
      const themeRole = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (themeRole && themeRole !== 'main' && window.Shopify.theme.id) {
        recsUrl += `&preview_theme_id=${window.Shopify.theme.id}`;
      }
      const response = await fetch(recsUrl);
      if (!response.ok) throw new Error('Failed to fetch recommendations');

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const recommendedSlides = doc.querySelectorAll('.carousel-slide');

      if (recommendedSlides.length > 0) {
        // Swap all slides in one atomic operation so the list never flashes empty
        // (the previous innerHTML='' + append loop caused a visible collapse/jump).
        recommendationsList.replaceChildren(...recommendedSlides);
        recommendationsList.dataset.loaded = 'true';
        
        const recommendedTabBtn = container.querySelector('.cart-drawer-upsell-tab[data-tab-target="recommended"]');
        if (recommendedTabBtn) recommendedTabBtn.style.display = '';
        if (wrapper && recommendedTabBtn && recommendedTabBtn.classList.contains('active')) {
          wrapper.style.display = 'block';
        }
      } else {
        // Recommendations API returned no results, keep tab visible with fallback collection 1
        const recommendedTabBtn = container.querySelector('.cart-drawer-upsell-tab[data-tab-target="recommended"]');
        if (recommendedTabBtn) recommendedTabBtn.style.display = '';
        if (wrapper && recommendedTabBtn && recommendedTabBtn.classList.contains('active')) {
          wrapper.style.display = 'block';
        }
      }
    } catch (e) {
      console.error('Error fetching dynamic recommendations:', e);
      // Fetch failed, keep tab visible with fallback collection 1
      const recommendedTabBtn = container.querySelector('.cart-drawer-upsell-tab[data-tab-target="recommended"]');
      if (recommendedTabBtn) recommendedTabBtn.style.display = '';
      if (wrapper && recommendedTabBtn && recommendedTabBtn.classList.contains('active')) {
        wrapper.style.display = 'block';
      }
    }
  }

  async function insertSectionCartDrawer() {
    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;

    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.classList.add('cart-drawer-items-wrapper');
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
      wrapper.appendChild(cartDrawerItems);
    }

    // Clean old upsell from inside the drawer wrapper but store active tab and loaded recommendations
    const existingUpsell = wrapper.querySelector('#cart-drawer-upsell');
    let activeTabTarget = null;
    let loadedRecommendationsHTML = null;
    if (existingUpsell) {
      const activeTab = existingUpsell.querySelector('.cart-drawer-upsell-tab.active');
      if (activeTab) {
        activeTabTarget = activeTab.dataset.tabTarget;
      }
      const recList = existingUpsell.querySelector('#cart-drawer-recommendations-list');
      if (recList && recList.dataset.loaded === 'true') {
        loadedRecommendationsHTML = recList.innerHTML;
      }
      existingUpsell.remove();
    }

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (upsells) {
      // Insert ONLY the #cart-drawer-upsell element — NOT the wrapper's full
      // innerHTML, which also contains a <style> tag. Re-inserting that <style>
      // on every rebuild was classified as a "non-upsell" change by the
      // MutationObserver below, which rescheduled insertSectionCartDrawer() in an
      // infinite loop (carousel rebuilt ~20x/sec -> constant flicker). The <style>
      // already lives in the hidden #cart-drawer-upsell-wrapper and applies globally.
      const tpl = upsells.querySelector('#cart-drawer-upsell');
      if (tpl) {
        const clone = tpl.cloneNode(true);
        // Also strip any <style>/<link>/<script> the product cards injected, so
        // re-inserting the clone on each cart change doesn't re-apply stylesheets
        // and reflow the cards. These assets are already loaded on the page.
        clone.querySelectorAll('style, link, script').forEach((node) => {
          if (node.tagName === 'STYLE' || node.tagName === 'LINK' || node.tagName === 'SCRIPT') {
            node.remove();
          }
        });
        wrapper.appendChild(clone);
      }
    }

    const activeUpsell = wrapper.querySelector('#cart-drawer-upsell');
    if (activeUpsell) {
      // Restore loaded recommendations to avoid fetching again
      if (loadedRecommendationsHTML) {
        const newRecList = activeUpsell.querySelector('#cart-drawer-recommendations-list');
        if (newRecList) {
          newRecList.innerHTML = loadedRecommendationsHTML;
          newRecList.dataset.loaded = 'true';
          // Also show the recommended tab button if it was hidden
          const recommendedTabBtn = activeUpsell.querySelector('.cart-drawer-upsell-tab[data-tab-target="recommended"]');
          if (recommendedTabBtn) recommendedTabBtn.style.display = '';
        }
      }

      // Restore active tab if we stored it
      if (activeTabTarget) {
        const tabs = activeUpsell.querySelectorAll('.cart-drawer-upsell-tab');
        const targetTab = Array.from(tabs).find(t => t.dataset.tabTarget === activeTabTarget);
        if (targetTab) {
          tabs.forEach(t => t.classList.remove('active'));
          targetTab.classList.add('active');
          
          const carousels = activeUpsell.querySelectorAll('.cart-drawer-upsell-carousel-wrapper');
          carousels.forEach(c => {
            if (c.id === `${activeTabTarget}-carousel`) {
              c.style.display = 'block';
            } else {
              c.style.display = 'none';
            }
          });
        }
      }

      const hasSlides = activeUpsell.querySelectorAll('.carousel-slide').length > 0;
      const hasRecommendedWrapper = activeUpsell.querySelector('#recommended-carousel') !== null;

      if (!hasSlides && !hasRecommendedWrapper) {
        activeUpsell.remove();
      } else {
        // One live-cart read per rebuild, shared by the heading and the recommendations.
        const liveCart = fetchLiveCart();
        updateGoalHeading(activeUpsell, liveCart);
        if (hasRecommendedWrapper && (!loadedRecommendationsHTML)) {
          await loadRecommendations(activeUpsell, liveCart);
        }
      }
    }
  }

  // One read of the live cart, shared by everything in a single rebuild.
  // Resolves to the cart, or null when it cannot be read.
  function fetchLiveCart() {
    return fetch('/cart.js')
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }

  // Goal-aware heading: the Liquid template renders the heading for the cart
  // state at page load, but this container is re-inserted from that stale
  // template on every cart change — so recompute from the live cart here.
  // The goals are proven steps: discounts a server-side check saw Shopify
  // really give (shop metafield alice.cart_offer). The quantity bar and its
  // typed goals are not read by the template. Each step carries its percent
  // ("p"), so the shopper's own cart can contradict a proof that is out of
  // date. This script asks Shopify nothing but /cart.js: a price check from
  // the page would be logged as add-to-cart.
  async function updateGoalHeading(upsellEl, liveCartPromise) {
    const title = upsellEl.querySelector('.cart-drawer-upsell-title');
    if (!title || !upsellEl.dataset.qtyGoals) return;
    let goals;
    try {
      goals = JSON.parse(upsellEl.dataset.qtyGoals);
    } catch (e) {
      return;
    }
    if (!Array.isArray(goals) || goals.length === 0) return;
    try {
      const cart = await (liveCartPromise || fetchLiveCart());
      if (!cart || typeof cart.item_count !== 'number') return; // keep the server-rendered heading
      const fallback = upsellEl.dataset.defaultTitle || 'YOU MAY ALSO LIKE';
      const count = cart.item_count;
      const steps = goals
        .filter((g) => g && typeof g.t === 'number' && g.r)
        .sort((a, b) => a.t - b.t);
      const reached = steps.filter((g) => count >= g.t).pop();
      if (reached && typeof reached.p === 'number') {
        const nowPercent =
          cart.original_total_price > 0 ? (cart.total_discount / cart.original_total_price) * 100 : 0;
        if (nowPercent + 0.5 < reached.p) {
          // The cart stands on a proven step and Shopify gives it less: promise nothing.
          title.textContent = fallback;
          return;
        }
      }
      const next = steps.find((g) => count < g.t);
      if (next) {
        const remaining = next.t - count;
        title.textContent =
          remaining === 1
            ? 'Add one of these to unlock ' + next.r
            : 'Add ' + remaining + ' more to unlock ' + next.r;
      } else {
        title.textContent = fallback;
      }
    } catch (e) {
      /* keep the server-rendered heading on any failure */
    }
  }

  window.insertSectionCartDrawer = insertSectionCartDrawer;

  // Call on script load
  insertSectionCartDrawer();

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer');
    if (!element) return;

    let timer;

    const observer = new MutationObserver((mutations) => {
      // Check if mutations are only related to the upsell element being modified, added, or removed
      let isOnlyUpsell = true;
      for (const mutation of mutations) {
        const targetElement = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (!targetElement) continue;

        if (targetElement.closest('#cart-drawer-upsell') || targetElement.closest('#cart-drawer-upsell-wrapper')) {
          continue;
        }
        if (targetElement.classList && targetElement.classList.contains('cart-drawer-items-wrapper')) {
          const addedElements = Array.from(mutation.addedNodes).filter(node => node.nodeType === 1);
          const removedElements = Array.from(mutation.removedNodes).filter(node => node.nodeType === 1);
          
          // Treat the upsell container AND non-rendering nodes (style/script/link)
          // as "not a real cart change" so they can never re-trigger a rebuild loop.
          const isUpsellNode = node =>
            node.id === 'cart-drawer-upsell' ||
            node.tagName === 'STYLE' || node.tagName === 'SCRIPT' || node.tagName === 'LINK' ||
            (node.querySelector && node.querySelector('#cart-drawer-upsell'));
          
          const addedUpsell = addedElements.some(isUpsellNode);
          const removedUpsell = removedElements.some(isUpsellNode);
          const otherAdded = addedElements.some(node => !isUpsellNode(node));
          const otherRemoved = removedElements.some(node => !isUpsellNode(node));
          
          if (addedUpsell || removedUpsell) {
            if (!otherAdded && !otherRemoved) {
              continue;
            }
          }
        }
        isOnlyUpsell = false;
        break;
      }

      if (isOnlyUpsell) return;

      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        insertSectionCartDrawer();
      }, 50);
    });

    // Observe class/attribute changes only on the root <cart-drawer> element (e.g. open, empty)
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      subtree: false
    });

    // Observe childList addition/removal of nodes on the entire subtree (no attributes)
    observer.observe(element, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }

  listenCartDrawer();
})();